import {
  FETCH_REFER_FRIEND_SCRIBE_REQUEST,
  FETCH_REFER_FRIEND_SCRIBE_SUCCESS,
  FETCH_REFER_FRIEND_SCRIBE_ERROR,
} from '../actions/referAFriend';

export const initialState = {
  isFetching: false,
  isReceived: false,
  scribeData: {},
};

function fetchReferFriendScribeRequest(state) {
  return { ...state, isFetching: true };
}

function fetchReferFriendScribeError(state) {
  return { ...state, isFetching: false };
}

function fetchReferFriendScribeSuccess(state, action) {
  return {
    ...state,
    scribeData: action.data,
    isFetching: false,
    isReceived: true,
  };
}

const ACTIONS = {
  [FETCH_REFER_FRIEND_SCRIBE_REQUEST]: fetchReferFriendScribeRequest,
  [FETCH_REFER_FRIEND_SCRIBE_SUCCESS]: fetchReferFriendScribeSuccess,
  [FETCH_REFER_FRIEND_SCRIBE_ERROR]: fetchReferFriendScribeError,
};

export default function referAFriend(state = initialState, action) {
  if (ACTIONS[action.type]) {
    return ACTIONS[action.type](state, action);
  }

  return state;
}
